import { z } from "zod";

// t("DOCTOR")
export const memberLicenceType = z.enum(["DOCTOR"]);
export type MemberLicenceType = z.infer<typeof memberLicenceType>;
